import React from "react";
import styled from "styled-components";
import {breakpoints} from "@/styles/sizes";
import Image from "next/image";
import StarIcon from "../../../../../public/images/star_gold.svg";

const Wrap = styled.section`
  width: 100%;
  padding: 100px 0;
  background: #fff;

    @media only screen and (${breakpoints.mobile}) {
        padding:20px;
    }

`;

const Inner = styled.div`
  max-width: 960px;
  margin: 0 auto;
  text-align: center;
`;

const ReviewLine = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  font-size: 14px;
  color: #253b2f;
  opacity: 0.9;

    @media only screen and (${breakpoints.mobile}) {
        flex-direction: column;
        gap:0;
    }
`;

const Stars = styled.span`
  color: #f3b33d;
  letter-spacing: 2px;
  font-size: 16px;
    padding-top: 5px;
`;

const Title = styled.h2`
  margin: 6px 0 10px;
  line-height: 1.15;
  font-weight: 800;
  text-transform: uppercase;
  color: #0b0f0e;
`;

const Subtitle = styled.p`
  margin: 0 auto 22px;
  max-width: 800px;
  font-size: 18px;
  line-height: 1.6;
  color: #222;
  opacity: 0.9;
    margin-bottom: 50px;
    font-family: 'Inter';

    @media only screen and (${breakpoints.mobile}) {
        margin-bottom: 20px;
    }

`;
const CTA = styled.a`
    margin: 12px 0 24px;
    background: #FF5A5F;
    color: #fff;
    border: 0;
    border-radius: 7px;
    padding: 20px 32px;
    font-size: 20px;
    font-weight: 700;
    cursor: pointer;
    text-decoration: none;
    font-family: 'Inter';

    /* Button */

    /* Auto layout */
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 15.9851px 35.5224px;

    width: fit-content;
    height: 67.97px;

    background: #FF5A5F;
    border-radius: 7.10448px;

    /* Inside auto layout */
    flex: none;
    order: 0;
    flex-grow: 0;

    align-self: center;
    justify-self: center;

`;
export default function VariantBBookEndSection({
   ctaButtonData,
    reviewOverlayData,
                                                   title,
                                                   cityName,
}) {
  return (
    <Wrap>
      <Inner>
        <ReviewLine>
          <Stars>
              <Image src={StarIcon} alt={'StarIcon'}/>
              <Image src={StarIcon} alt={'StarIcon'}/>
              <Image src={StarIcon} alt={'StarIcon'}/>
              <Image src={StarIcon} alt={'StarIcon'}/>
              <Image src={StarIcon} alt={'StarIcon'}/>
          </Stars>
          <span style={{fontFamily:'Playfair Display', color:'#144733', fontWeight:'bold'}}>{reviewOverlayData?.data?.leftText}</span>
        </ReviewLine>
        <Title>{`READY TO TASTE THE REAL ${cityName}?`}</Title>
        <Subtitle>{`Book our award-winning  ${title} before it fills up!`}</Subtitle>
          {
              ctaButtonData?.item_link && <div
                  style={{
                      display:'flex',
                      justifyContent:'center',
                      alignItems:'center',
                  }}
              >
                <CTA href={ctaButtonData?.item_link ?? '#'}>{ctaButtonData?.item_title ?? 'Book your Tour'}</CTA>
              </div>
          }
      </Inner>
    </Wrap>
  );
}
